import BootstrapModal from "../../components/BootstrapModal";
import {Formik, Form, Field} from 'formik'
import TextField from "../../components/TextField";
import * as Yup from 'yup'
import PMSCheckBox from "../../components/PMSCheckBox";
import FormSelect from "../../components/FormSelect";
import {ProgressSpinner} from "primereact/progressspinner";
import { Hidden } from "@mui/material";

const CompetencyTitleIndicatorForm = ({modal, competencyTitleIndicatorID,competencyID,userRoleID, indicatorSequenceNo,indicatorTitle,
indicatorTitleBangla,indicatorValue,active, isLoading,setactiveCompetencyTitleNames,setactiveUserRoleNames, onSubmit, onHide}) => {
    const validation = Yup.object({
        userRoleID:Yup.number().positive('please select role'),
        competencyID:  Yup.number().positive('please select competency'),
        indicatorSequenceNo: Yup.string().required(),
        indicatorTitle: Yup.string().required(),
        //indicatorTitleBangla: Yup.string().required(),
		indicatorValue: Yup.number().positive('This field is Required'),
    })
    return (<>
        <BootstrapModal headerText="Add Competency Indicator" size={40} visible={modal} onHide={onHide}>
            <Formik
                validationSchema={validation}
                initialValues={{
                    competencyTitleIndicatorID: competencyTitleIndicatorID, 
                    competencyID: competencyID,
                    userRoleID:userRoleID,
				    indicatorSequenceNo: indicatorSequenceNo,
                    indicatorTitle: indicatorTitle,
				    indicatorTitleBangla: indicatorTitleBangla,
                    indicatorValue: indicatorValue, 
                    active: active}}
                onSubmit={onSubmit}>
                {formik =>

                    (<>
                        <Form>
                            <Field type="hidden" name="assestmentTitleIndicatorID"/>                                                    
                            <FormSelect id="userRoleID" name="userRoleID" options={setactiveUserRoleNames}/>
                            <FormSelect id="competencyID" name="competencyID" options={setactiveCompetencyTitleNames}/>						
                            <TextField label={'Sequence No'} type="text" name="indicatorSequenceNo"/>							
                            <TextField label={'Indicator Title'} type="text" name="indicatorTitle"/>							
                            <Field label={'Indicator Title(Bangla)'} type="hidden" name="indicatorTitleBangla"/>
                            <TextField label={'Indicator Value'} type="text" name="indicatorValue"/> 
                            <PMSCheckBox label={'Active'} name={'active'} id={'active'}/>
                            {isLoading ? <ProgressSpinner style={ {height:30,width:30} }/> : <button type="submit" className="btn btn-primary">{competencyTitleIndicatorID === 0 ? 'Save' : 'Update'} </button>}

                        </Form>
                    </>)}

            </Formik>
        </BootstrapModal>
    </>)
}

export default CompetencyTitleIndicatorForm